import type { AdminDeletionSummary, AdminDeletionTarget } from '@cpce/shared';
import { useQuery } from '@tanstack/react-query';
import { useCommiteeIdFromUrl } from '@/utils/router';
import { apiGet } from '../api.utils';
import { commiteeMutation, MutationMethod } from '../mutations.utils';

const ADMIN_DELETIONS_URL = '/commitee/:commiteeId/admin-deletions';

// Not `commiteeQuery`: a refused deletion is an expected answer here, shown in the modal, not a
// failure to toast. Never cached either — the preview must reflect the data at the moment it opens.
export function useAdminDeletionPreview(target: AdminDeletionTarget, id: number, enabled: boolean) {
  const commiteeId = useCommiteeIdFromUrl();
  return useQuery({
    queryKey: ['admin-deletion-preview', commiteeId, target, id],
    queryFn: () =>
      apiGet<AdminDeletionSummary>(`/commitee/${commiteeId}/admin-deletions/${target}/${id}`),
    enabled: enabled && commiteeId !== undefined,
    retry: false,
    gcTime: 0,
  });
}

export function useAdminDelete(target: AdminDeletionTarget, id: number) {
  return commiteeMutation<AdminDeletionSummary>({
    url: `${ADMIN_DELETIONS_URL}/${target}/${id}`,
    method: MutationMethod.DELETE,
    successMessage: 'Suppression définitive effectuée',
  });
}
